import React, { Component } from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import TopHeader from "../template/TopHeader";
import { voucherActions } from "../../_actions/voucher.actions";
import { productAction } from "../../_actions/product.action";

import { GrClose } from "react-icons/gr";
import { FaSearch } from "react-icons/fa";

class SelectVoucher extends Component {
  constructor(props) {
    super(props);
    this.state = {
      voucherList: [],
      searchKey: "",
      loading: true,
      error: "",
      selectedVoucher: null,
      indexId: null
    };

    this.handleSearch = this.handleSearch.bind(this);
    this.selectVoucher = this.selectVoucher.bind(this);
  }

  componentDidMount() {
    const body = document.getElementsByClassName("body_container")[0];
    body.classList.remove("cm_bg_white");
    body.classList.add("body_bg_lightGray");

    const { indexId } = this.props.match.params;
    console.log('componentDidMount - props.match.params:', this.props.match.params);
    console.log('componentDidMount - indexId from URL:', indexId);
    
    // Convert indexId to number to match product behavior
    const numericIndexId = Number(indexId);
    console.log('componentDidMount - numericIndexId:', numericIndexId);
    
    this.setState({ indexId: numericIndexId });

    this.fetchVouchers();
  }

  fetchVouchers() {
    this.setState({ loading: true });
    
    this.props.dispatch(voucherActions.getVoucherCatalogs())
      .then(response => {
        console.log('Voucher response:', response);
        
        try {
          let voucherList = [];
          
          // Check for the specific response format we're getting
          if (response.data && response.data.statusCode === 1 &&
              response.data.responseData &&
              response.data.responseData.data &&
              response.data.responseData.data.vouchers) {
            
            voucherList = response.data.responseData.data.vouchers;
          }
          // Check for catalogs array in the new API format
          else if (response.data && response.data.statusCode === 1 &&
                  response.data.responseData && response.data.responseData.data &&
                  response.data.responseData.data.catalogs) {
            console.log('Found catalogs in new API format');
            voucherList = response.data.responseData.data.catalogs;
          }
          // Direct access to vouchers array if it exists
          else if (response.data && response.data.responseData && response.data.responseData.vouchers) {
            voucherList = response.data.responseData.vouchers;
          }
          // Handle other possible formats as fallback
          else if (response.data && response.data.status === 1 && response.data.data) {
            // Check if data.vouchers exists
            if (response.data.data.vouchers && Array.isArray(response.data.data.vouchers)) {
              voucherList = response.data.data.vouchers;
            } else if (response.data.data.catalogs && Array.isArray(response.data.data.catalogs)) {
              console.log('Found catalogs in direct API format');
              voucherList = response.data.data.catalogs;
            } else if (Array.isArray(response.data.data)) {
              voucherList = response.data.data;
            }
          }
          else if (response.data && response.data.statusCode === 1 && Array.isArray(response.data.responseData.result)) {
            voucherList = response.data.responseData.result;
          }
          else if (response.data && response.data.vouchers) {
            voucherList = response.data.vouchers;
          }
          
          this.setState({
            voucherList: Array.isArray(voucherList) ? voucherList : [],
            loading: false
          });
        } catch (err) {
          console.error('Error processing voucher response:', err);
          this.setState({
            voucherList: [],
            error: "Failed to process vouchers",
            loading: false
          });
        }
      })
      .catch(error => {
        console.error('Error fetching vouchers:', error);
        this.setState({
          voucherList: [],
          error: "Failed to load vouchers",
          loading: false
        });
      });
  }

  handleSearch(e) {
    const searchValue = e.target.value;
    console.log('Search value:', searchValue);
    this.setState({ searchKey: searchValue });
  }

  selectVoucher(voucher) {
    if (!voucher || (!voucher.id && !voucher._id)) {
      console.error('Invalid voucher selected:', voucher);
      return;
    }
    
    const { indexId } = this.state;
    console.log('selectVoucher - indexId:', indexId);
    
    // Create a voucher object with the necessary properties
    const selectedVoucher = {
      _id: voucher.id || voucher._id,
      id: +indexId, // Convert to number to match product behavior
      indexId: +indexId, // Convert to number to match product behavior
      voucherName: voucher.name || (voucher.type === 'cash' ? `${voucher.currency}${voucher.value}` : `${voucher.value} mins`),
      voucherPrice: voucher.value || 0,
      voucherCode: voucher.code || '',
      voucherType: voucher.type || 'standard',
      voucherDescription: voucher.status || '',
      currency: voucher.currency || '£',
      type: "voucher",
      code: voucher.code || '',
      value: voucher.value || 0,
      name: voucher.name || ''
      // Removed retailPrice property as it causes vouchers to be categorized as products
    };
    
    // Log the voucher object for debugging
    console.log('SelectVoucher - created voucher object:', selectedVoucher);

    console.log('Selected voucher:', selectedVoucher);

    // Dispatch the selected voucher using the same action as products
    console.log('Dispatching productAction.selectCheckoutItem with:', selectedVoucher);
    this.props.dispatch(productAction.selectCheckoutItem(selectedVoucher));

    // Navigate back to the checkout page
    const { state } = this.props.location;
    if (state && state.previousPageUrl) {
      this.props.history.push({
        pathname: state.previousPageUrl,
        state: {
          pageLoadingStatus: this.state.currentLoadingStatus,
          previousPageUrl: this.props.location.pathname,
          fromVoucherSelection: true, // Use a different flag to avoid early return in setSelectedVoucher
          indexId: +this.state.indexId // Pass the indexId to identify the item
        }
      });
    } else {
      const salonId = this.props.match.params.salonId;
      this.props.history.push(`/new-checkout/${salonId}`);
    }
  }

  render() {
    const { voucherList, searchKey, loading, error } = this.state;
    
    // Debug the voucher list
    console.log('Render - voucherList:', voucherList);
    console.log('Render - voucherList length:', voucherList ? voucherList.length : 0);
    
    // Ensure voucherList is an array
    const safeVoucherList = Array.isArray(voucherList) ? voucherList : [];
    console.log('Render - safeVoucherList:', safeVoucherList);
    console.log('Render - safeVoucherList length:', safeVoucherList.length);
    
    // Check if vouchers have the expected properties
    if (safeVoucherList.length > 0) {
      console.log('First voucher properties:', Object.keys(safeVoucherList[0]));
      console.log('First voucher:', safeVoucherList[0]);
    }
    
    // Filter vouchers based on search key and status (only show active vouchers)
    const filteredVouchers = safeVoucherList.filter(voucher => {
      if (!voucher) return false;
      
      // Filter out inactive vouchers
      const status = (voucher.status || '').toLowerCase();
      if (status !== 'active') {
        return false;
      }
      
      // Get searchable properties from the voucher
      const code = voucher.code || '';
      const type = voucher.type || '';
      const value = voucher.value ? `${voucher.value}` : '';
      const currency = voucher.currency || '';
      
      // If search key is empty, return all active vouchers
      if (!searchKey || searchKey.trim() === '') {
        return true;
      }
      
      // Check if any property contains the search key
      const searchLower = searchKey.toLowerCase();
      return (
        code.toLowerCase().includes(searchLower) ||
        type.toLowerCase().includes(searchLower) ||
        value.toLowerCase().includes(searchLower) ||
        currency.toLowerCase().includes(searchLower) ||
        `${currency}${value}`.toLowerCase().includes(searchLower)
      );
    });
    
    console.log('Render - filteredVouchers:', filteredVouchers);
    console.log('Render - filteredVouchers length:', filteredVouchers.length);

    // Function to handle cancel button click
    const handleCancel = () => {
      const { state } = this.props.location;
      if (state && state.previousPageUrl) {
        this.props.history.push(state.previousPageUrl);
      } else {
        const salonId = this.props.match.params.salonId;
        this.props.history.push(`/new-checkout/${salonId}`);
      }
    };

    return (
      <div>
        <div className="h_n">
          <div className="body_container cm_bg_white">
            <TopHeader
              title="Select a Voucher"
              headerButtonStatus={true}
              cancelButton={true}
              {...this.props}
            />
            <div className="container">
              <div className="row ">
                <div className="col-md-1"></div>
                <div className="cm_search_wrapper client_search m-0 col-md-10 mt-4">
                  <input
                    type="text"
                    className="form-control "
                    placeholder="Search…"
                    name="search"
                    value={searchKey}
                    onChange={this.handleSearch}
                    autoComplete="off"
                  />
                  <i className="fa fa-search mr-4" />
                </div>
                <div className="col-md-1"></div>
              </div>
            </div>
            <div className="container">
              <div className="row black_heading">
                <div className="col-md-1"></div>
                <div className="col-md-10 d-flex product">
                  <div className="col-md-6">
                    <h5>Name</h5>
                  </div>
                  <div className="col-md-6">
                    <h5>Value</h5>
                  </div>
                </div>
                <div className="col-md-1"></div>
              </div>
            </div>

            <div className="container">
              <div className="row black_heading">
                <div className="col-md-1"></div>
                <div className="col-md-10 product_data p-0 overflow-scroll">

                {loading ? (
                  <div className="text-center mt-5">
                    <div className="spinner-border" role="status">
                      <span className="sr-only">Loading...</span>
                    </div>
                  </div>
                ) : error ? (
                  <div className="alert alert-danger mt-3" role="alert">
                    {error}
                  </div>
                ) : filteredVouchers.length === 0 ? (
                  <div className="alert alert-info mt-3" role="alert">
                    No vouchers found
                  </div>
                ) : (
                  <table className="table table-striped border-0">
                    <tbody className="">
                      {filteredVouchers.map((voucher, index) => (
                        <tr
                          key={voucher.id || voucher._id}
                          className="product_row"
                          onClick={() => this.selectVoucher(voucher)}
                        >
                          <td className="align-middle border-0" style={{ width: '50%' }}>
                            <span className="text-dark pl-4">{voucher.name}</span>
                          </td>
                          <td className="align-middle border-0" style={{ width: '50%' }}>
                            <span className="text-dark">{voucher.currency}{parseFloat(voucher.value).toFixed(2)}</span>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                )}
                </div>
                <div className="col-md-1"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    ...state
  };
}

export default connect(mapStateToProps)(SelectVoucher);